/**
 * 港间路径兜底：无后端 MARNET 航段时用直线（不做贝塞尔弧）。
 * 坐标：Leaflet [lat, lon]
 *
 * 美线跨日界线（±180°）时，若相邻点经度从 +170 跳到 -170，
 * Leaflet 会在平面上横穿整张图（经亚欧），看起来像「从左边北太平洋接着画」。
 * 须把经度展开为连续值（-170 → +190），线才会从右边北太平洋接到美西。
 */

/** 将 lon 对齐到与 refLon 同一「展开帧」（差值落在 (-180, 180]） */
export function alignLon(lon, refLon) {
  if (!Number.isFinite(lon) || !Number.isFinite(refLon)) return lon
  let x = lon
  while (x - refLon > 180) x -= 360
  while (x - refLon < -180) x += 360
  return x
}

/**
 * 展开折线经度，使相邻点不跨 ±180 突变。
 * @param {Array<[number, number]>} points Leaflet [lat, lon]
 * @returns {Array<[number, number]>}
 */
export function unwrapLatLngs(points) {
  if (!points || !points.length) return []
  const out = []
  let prevLon = null
  for (let i = 0; i < points.length; i++) {
    const p = points[i]
    if (!p || !Number.isFinite(p[0]) || !Number.isFinite(p[1])) continue
    let lon = p[1]
    if (prevLon != null) {
      lon = alignLon(lon, prevLon)
    }
    out.push([p[0], lon])
    prevLon = lon
  }
  return out
}

/**
 * 将已展开的一段路径整体平移，使首点落在 refLon 所在帧（多段航线共用同一世界副本）。
 */
export function shiftPathToFrame(path, refLon) {
  if (!path || !path.length || !Number.isFinite(refLon)) return path || []
  const delta = alignLon(path[0][1], refLon) - path[0][1]
  if (delta === 0) return path
  return path.map(ll => [ll[0], ll[1] + delta])
}

/**
 * 单点对齐到展开帧（港口 / 船位）。
 */
export function alignLatLng(ll, refLon) {
  if (!ll || !Number.isFinite(ll[0]) || !Number.isFinite(ll[1])) return ll
  if (!Number.isFinite(refLon)) return [ll[0], ll[1]]
  return [ll[0], alignLon(ll[1], refLon)]
}

export function buildStraightRoute(fromLl, toLl) {
  if (!fromLl || !toLl) return []
  if (!Number.isFinite(fromLl[0]) || !Number.isFinite(fromLl[1])
    || !Number.isFinite(toLl[0]) || !Number.isFinite(toLl[1])) {
    return []
  }
  return unwrapLatLngs([fromLl, toLl])
}
